import { useLanguageData } from '@/common/hooks/useLanguageData';
import PopUp from '../../../../../common/components/PopUp';
import {
	Title,
	Wrapper,
	ExampleScene,
	Text,
	IconItem,
	IconImage,
	SectionWrapper,
	Items,
} from './ScenesListTutorialPopup.styles';
import ExampleSceneImage from '../../images/buying-shoes.png';
import HeartIcon from '../../images/heart-purple.svg';
import CheckmarkIcon from '../../images/checkmark.svg';
import GradientButton from '@/common/components/custom/buttons/GradientButton';

type Props = { onClose: () => void };

function ScenesListTutorialPopup({ onClose }: Props) {
	const langData = useLanguageData('features.sceneV3');

	return (
		<PopUp setClose={onClose}>
			<Wrapper>
				<SectionWrapper>
					<Title>{langData.howToUseScenes}</Title>
					<ExampleScene src={ExampleSceneImage} />
					<Text style={{ width: '280px', textAlign: 'center' }}>
						{langData.clickSelectedScene}
					</Text>
					<Items>
						<IconItem>
							<IconImage src={HeartIcon} />
							<Text>{langData.clickToMarkAsFavorite}</Text>
						</IconItem>
						<IconItem>
							<IconImage src={CheckmarkIcon} />
							<Text>{langData.youSeeWhenSceneIsDone}</Text>
						</IconItem>
					</Items>
				</SectionWrapper>

				<SectionWrapper>
					<Text>
						<strong>{langData.howLearningLookLike}</strong>
					</Text>
					<Text style={{ width: '280px' }}>{langData.learningIsAbout}</Text>
					<GradientButton
						onClick={onClose}
						title={langData.close}
						style={{ width: '200px', aspectRatio: '4.5', marginTop: 20 }}
					/>
				</SectionWrapper>
			</Wrapper>
		</PopUp>
	);
}

export default ScenesListTutorialPopup;
